import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgLiveDealer = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M7.25 12.554v.033zM19.112 4.27a.75.75 0 0 0-.34 1.46l1.072.25a.53.53 0 0 1 .393.628v.001l-1.71 7.236a.537.537 0 0 1-.637.391l-.859-.2a.75.75 0 1 0-.34 1.461l.86.2.003.001a2.036 2.036 0 0 0 2.432-1.503l.001-.002 1.71-7.242v-.003A2.03 2.03 0 0 0 20.19 4.52zM3.765 11.303l.006.01z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M8.75 4.402c0-.332.291-.652.702-.652h5.097c.408 0 .701.318.701.652v8.196c0 .332-.291.652-.701.652H14a.75.75 0 0 0 0 1.5h.549c1.193 0 2.201-.948 2.201-2.152V4.402c0-1.215-1.019-2.152-2.201-2.152H9.452c-.78 0-1.481.405-1.873 1.021a1.36 1.36 0 0 0-1.028.243c-.231.16-.4.362-.5.5a3 3 0 0 0-.162.247l-.012.02L2.5 10.24a1.9 1.9 0 0 0-.055 1.775l.036.068.12.217.405.735a1388 1388 0 0 0 2.346 4.216h-.335a.766.766 0 0 0-.766.765v2.97a.765.765 0 0 0 .766.765h7.968a.766.766 0 0 0 .766-.765v-2.97a.765.765 0 0 0-.766-.765h-.559c.269-.441.562-1.084.6-1.845.03-.607-.16-1.276-.38-1.797a5 5 0 0 0-.39-.744 3 3 0 0 0-.132-.188l.612-2.612a2.23 2.23 0 0 0-1.709-2.689l-.272-.065h-.002a2.22 2.22 0 0 0-2.002.514zM7.069 17.25l-.333-.597-2.419-4.346-.517-.937-.02-.04a.4.4 0 0 1 .024-.351l3.381-5.963L7.194 5v.002l-.002.001a1 1 0 0 1 .058-.088v8.317a.75.75 0 0 0 1.5 0v-.576l.782-3.342a.73.73 0 0 1 .876-.544l.313.074h.002a.73.73 0 0 1 .544.876 1 1 0 0 0-.017.106l-.68 2.903a.75.75 0 0 0 .302.787s.045.043.126.167c.086.132.18.308.265.51.179.422.277.85.263 1.136v.002c-.022.438-.2.846-.398 1.165a3.3 3.3 0 0 1-.34.454l-.018.019-.001.002a.75.75 0 0 0-.176.279zm-.424 1.5H5.75v1.5h6.5v-1.5zm-2.88-7.447.006.01zM3.765 11.303l.006.01z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgLiveDealer;
